import useViewportSize, { type ViewportSize } from "common/utilities/hooks/useViewportSize/useViewportSize";
import { useEffect, useRef } from "react";

/**
 * Trigger onResize callback whenever the user resize the window.
 * Ignore zoom level changes by using window.outer properties.
 */
function useWindowResize(onResize: () => void) {
  const viewportSize = useViewportSize();
  const previousWindowSize = useRef<ViewportSize>({
    width: window.outerWidth,
    height: window.outerHeight,
  });

  useEffect(() => {
    if (
      window.outerWidth !== previousWindowSize.current.width ||
      window.outerHeight !== previousWindowSize.current.height
    ) {
      onResize();
    }

    previousWindowSize.current = {
      width: window.outerWidth,
      height: window.outerHeight,
    };
  }, [viewportSize, onResize]);
}

export default useWindowResize;
